var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('b-button',{staticClass:"w-100",attrs:{"variant":_vm.variant,"type":_vm.type}},[(!_vm.isLoading)?[_vm._t("default")]:_c('b-spinner',{attrs:{"variant":_vm.loadingVariant}})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }